/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  description: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  expiration_date: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .nullable(),
  filter_using_ips: Yup.boolean(),
  valid_ips: Yup.string().when('filter_using_ips', {
    is: true,
    then: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  }),
});
